export default "__VITE_ASSET__DTHL_863__"